import Cookie from 'js-cookie'

const COOKIE_TO_SELECTOR_MAP = {
  'mm_cookie_utm_term': 'a[href*="link.gemsociety.org"]'
}

export default class LinkManager {
  
  constructor() {
    this.init();
  }

  init() {
    for(const cookieName in COOKIE_TO_SELECTOR_MAP) {
      const cookieValue = Cookie.get(cookieName);

      if(cookieValue) {
        const selector = COOKIE_TO_SELECTOR_MAP[cookieName];
        const links = document.querySelectorAll(selector);
        
        links.forEach((link) => {
          this.replaceLinkUrl(link, cookieValue);
        });
      }
    }
  }

  replaceLinkUrl(link, cookieValue) {
    const url = new URL(link.href);
    url.pathname = url.pathname.substr(-1) === '/' ? url.pathname.slice(0, -1) + '-' + cookieValue + '/' : url.pathname + '-' + cookieValue + '/';

    link.href = url.toString();
  }
}